import { render, staticRenderFns } from "./EventRiwayat.vue?vue&type=template&id=343c05be&scoped=true"
import script from "./EventRiwayat.vue?vue&type=script&lang=js"
export * from "./EventRiwayat.vue?vue&type=script&lang=js"
import style0 from "./EventRiwayat.vue?vue&type=style&index=0&id=343c05be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c05be",
  null
  
)

export default component.exports